import {Observable} from 'rxjs';
import {filter}     from 'rxjs/operators';

import IConfig from '../Interfaces/IConfig';

const createConsumerConfig = (config$: Observable<IConfig>): Observable<IConfig> =>
    config$
        .pipe(
            filter(nextOptions => nextOptions && Object.keys(nextOptions).length > 0)
        );

export default createConsumerConfig;